import { createApp } from 'vue';
import careerD1PTable from '../../../career/D1PTable.vue'
const appElements = document.querySelectorAll('.vue-career-render-d1')

Array.from(appElements).forEach(element => {
    createApp(careerD1PTable).mount(element);
});
